import { Component } from '@angular/core';
import { Category } from 'app/model/category';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectCategories } from 'app/store/selectors/product.selectors';

/**
 * App footer component
 * @export
 * @class OrgLayoutFooterComponent
 */
@Component({
  selector: 'org-layout-footer',
  templateUrl: './org-layout-footer.component.html',
  styleUrls: ['./org-layout-footer.component.scss'],
})
export class OrgLayoutFooterComponent {
  /**
   * Store reference (product.categories)
   */
  categories$: Observable<Category[]>;

  /**
   * Creates an instance of OrgLayoutFooterComponent.
   * @param {Store} store
   */
  constructor(private store: Store) {
    this.categories$ = this.store.select(selectCategories);
  }
}